document.addEventListener('click', function (event) {
  const button = event.target.closest('.cart-drawer__upsell-cta');
  if (!button || button.disabled) return;

  event.preventDefault();

  const variantId = button.dataset.variantId;
  const removeVariantId = button.dataset.removeVariantId;
  const cartErrors = document.getElementById('CartDrawer-CartErrors');

  button.disabled = true;
  button.classList.add('loading');
  if (cartErrors) cartErrors.textContent = '';

  fetch(window.routes.cart_add_url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status) {
        throw new Error(data.description || 'Could not add the Blessing to your cart.');
      }

      // Target by variant id (as a string - Shopify's API rejects a raw
      // JSON number here), not line position. Confirmed via direct testing
      // against the live cart API that adding a variant does not
      // reliably append at the end of the cart - it can insert at line 1,
      // pushing the original item to line 2. A line number captured at
      // page-render time goes stale the moment that happens, and the
      // change request ends up removing the just-added Blessing variant
      // instead of the original - which nets out to no visible change at
      // all, exactly the symptom this was causing. Variant id is stable
      // regardless of how the cart reorders itself.
      return fetch(window.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: String(removeVariantId), quantity: 0 }),
      });
    })
    .then((response) => response.json())
    .then((data) => {
      if (data.status) {
        // The Blessing variant from step 1 is already in the cart at this
        // point - only removing the original (without-blessing) line
        // failed. Surfacing this distinctly, since a plain retry won't
        // necessarily fix a cart already left in this partial state.
        throw new Error('added-but-not-removed');
      }

      // Re-render via a plain GET + on-demand section rendering
      // (?section_id=), the same mechanism the theme's own CartItems
      // #onCartUpdate already uses elsewhere. cache: 'no-store' is
      // required here - without it the browser can silently serve back a
      // cached response for this exact URL from before the mutation,
      // which looks identical to the request just quietly failing (no
      // error, but the drawer never visibly updates).
      return Promise.all([
        fetch(`${window.routes.cart_url}?section_id=cart-drawer`, { cache: 'no-store' }).then((r) => r.text()),
        fetch(`${window.routes.cart_url}?section_id=cart-icon-bubble`, { cache: 'no-store' }).then((r) => r.text()),
      ]);
    })
    .then(([drawerHtml, bubbleHtml]) => {
      const drawerDoc = new DOMParser().parseFromString(drawerHtml, 'text/html');
      const drawerTarget = document.querySelector('.drawer__inner');
      const drawerSource = drawerDoc.querySelector('.drawer__inner');
      if (drawerTarget && drawerSource) {
        drawerTarget.replaceWith(drawerSource);
      } else {
        console.warn('[cart-drawer-upsell] could not find .drawer__inner to refresh, reloading instead');
        window.location.reload();
        return;
      }

      const bubbleDoc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
      const bubbleTarget = document.getElementById('cart-icon-bubble');
      const bubbleSource = bubbleDoc.getElementById('cart-icon-bubble');
      if (bubbleTarget && bubbleSource) {
        bubbleTarget.replaceWith(bubbleSource);
      }
    })
    .catch((error) => {
      console.error('[cart-drawer-upsell]', error);
      const errors = document.getElementById('CartDrawer-CartErrors');
      if (errors) {
        errors.textContent =
          error && error.message === 'added-but-not-removed'
            ? 'The Blessing was added, but your original item could not be updated. Please refresh the page.'
            : window.cartStrings
              ? window.cartStrings.error
              : 'Something went wrong. Please try again.';
      }
      button.disabled = false;
      button.classList.remove('loading');
    });
});
